import { useAppSelector } from "@/stores/hook";
import PreferenceViewMode from "./PreferenceViewMode";
import PreferenceEditMode from "./PreferenceEditMode";

export default function Preference() {
  const { isEditMode } = useAppSelector((state) => state.leadFunctional);

  if (isEditMode) {
    return <PreferenceEditMode />;
  } else return <PreferenceViewMode />;
}
